export default __webpack_public_path__ + "static/media/EC.a38155cc.ico";